import React from "react";
import { Link } from "react-router-dom";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "../ui/sheet";
import { t } from "../../lib/i18n";

const ITEMS = [
  { to: "/", label: t("nav.home"), testid: "drawer-link-home" },
  { to: "/services", label: t("nav.services"), testid: "drawer-link-services" },
  { to: "/plan", label: t("nav.plan"), testid: "drawer-link-plan" },
  { to: "/faqs", label: "FAQs", testid: "drawer-link-faqs" },
  { to: "/help", label: t("nav.help"), testid: "drawer-link-help" },
  { to: "/policies/about", label: "About", testid: "drawer-link-about" },
  { to: "/track", label: "Track your request", testid: "drawer-link-track" },
];

export default function MobileDrawer({ open, onOpenChange }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        data-testid="mobile-drawer"
        className="border-l-[#EAE3D2] bg-[#FAF7F2] text-[#1A1A1A]"
      >
        <SheetHeader>
          <SheetTitle className="font-display text-2xl tracking-[0.06em]">
            Shutter<span className="text-[#C8A24B]">KART</span>
          </SheetTitle>
        </SheetHeader>
        <ul className="mt-8 space-y-1">
          {ITEMS.map((item) => (
            <li key={item.to}>
              <Link
                to={item.to}
                data-testid={item.testid}
                onClick={() => onOpenChange(false)}
                className="block rounded-md px-3 py-3 text-lg text-[#1A1A1A]/85 transition hover:bg-[#EAE3D2]/40 hover:text-[#1A1A1A]"
              >
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </SheetContent>
    </Sheet>
  );
}
